module.exports = __webpack_public_path__ + "static/media/logo-en.75223216.png";